import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestUnidades({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'unidades', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteUnidade({ payload }) {
  try {
    const { idunidade, params } = payload;

    yield call(api.delete, `unidades/${idunidade}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { unidade, params } = payload;

    yield call(api.post, 'unidades', unidade);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/cadunidade');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idunidade } = payload;

    const { data } = yield call(api.get, `unidades/${idunidade}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { unidade, params } = payload;

    yield call(api.put, 'unidades', unidade);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/cadunidade');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'unidades', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@unidade/UNIDADES_IN_REQUEST', requestUnidades),
  takeLatest('@unidade/DELETE_UNIDADE', deleteUnidade),
  takeLatest('@unidade/SUCCESS_REMOVE', requestUnidades),
  takeLatest('@unidade/STORE_UNIDADE', store),
  takeLatest('@unidade/FIND_UNIDADE', find),
  takeLatest('@unidade/UPDATE_UNIDADE', update),
  takeLatest('@unidade/RECORD_FILTERING', applyedFilters),
]);
